import { render } from "./MusicList.vue?vue&type=template&id=43b3a178"
import script from "./MusicList.vue?vue&type=script&lang=js"
export * from "./MusicList.vue?vue&type=script&lang=js"

import "./MusicList.vue?vue&type=style&index=0&id=43b3a178&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__